export enum UserPreviousPageForCompanyMovement {
	PAYMENT_METHOD = 'PAYMENT_METHOD',
	VERIFICATION = 'VERIFICATION',
	WITHDRAW = 'WITHDRAW',
	LINKED_CARDS = 'LINKED_CARDS',
	CLAIM_IBAN = 'CLAIM_IBAN',
	ORDER_DEBIT_CARD = 'ORDER_DEBIT_CARD',
}

enum UserContractCompanyId {
	LT = 'eaa8592a-b22c-44fb-be10-500cd42710b2',
	EE = 'd23ee85a-cf78-49a7-a032-8dc3160443f1',
	SF_BVI = 'b45cf997-c9a3-4cb6-a119-920835b60213',
	SF_SYSTEMS_BVI = '52275747-a6ac-497f-b07c-d6e8575d0ec0',
}

export default UserContractCompanyId;
